import { ElMessage } from "element-plus";
import { defineStore } from "pinia";
import { 
    getGroundResourcesDataTableData, getGroundResourcesTypeOptions, editGroundResourcesData, deleteGroundResourcesData,
    getGroundResourcesTypeTableData, editGroundResourcesType, deleteGroundResourcesType,
    getFacilityTypeTableData, getFacilityTypeOptions, editFacilityType, deleteFacilityType,
    getFacilityDataTableData, editFacilityData, deleteFacilityData,
    getAircraftTableData, editAircraft, deleteAircraft, getAircraftDataById, getSubordinateCompanyOptions
} from "@/services";

const useDataManagementStore = defineStore("dataManagement", {
    state: () => ({
        pageTitle: '',
        aircraftDrawerTab: 'info',
        groundResourcesTypeOptions: [],
        facilityTypeOptions: [],
        subordinateCompanyOptions: [],
        tableAllData: {},
    }),
    actions: {
        async getTableAllData(type, params) {
            let result = {}
            switch(type) {
                case 'groundResourcesData': result = await getGroundResourcesDataTableData(params);break;
                case 'groundResourcesType': result = await getGroundResourcesTypeTableData(params);break;
                case 'facilityType': result = await getFacilityTypeTableData(params);break;
                case 'facilityData': result = await getFacilityDataTableData(params);break;
                case 'aircraft': result = await getAircraftTableData(params);break;
            }
            this.tableAllData = result.data
        },
        async getAircraftDataById(params) {
            let result = await getAircraftDataById(params)
            return result.data
        },

        async editTableData(type, params) {
            let result = {}
            switch(type) {
                case 'groundResourcesData': result = await editGroundResourcesData(params);break;
                case 'groundResourcesType': result = await editGroundResourcesType(params);this.getGroundResourcesTypeOptions();break;
                case 'facilityType': result = await editFacilityType(params);this.getFacilityTypeOptions();break;
                case 'facilityData': result = await editFacilityData(params);break;
                case 'aircraft': result = await editAircraft(params);break;
            }
            return result
        },
        async deleteTableData(type, params) {
            let result = {}
            switch(type) {
                case 'groundResourcesData': result = await deleteGroundResourcesData(params);break;
                case 'groundResourcesType': result = await deleteGroundResourcesType(params);this.getGroundResourcesTypeOptions();break;
                case 'facilityType': result = await deleteFacilityType(params);this.getFacilityTypeOptions();break;
                case 'facilityData': result = await deleteFacilityData(params);break;
                case 'aircraft': result = await deleteAircraft(params);break;
            }
            return result
        },

        async getGroundResourcesTypeOptions() {
            let result = await getGroundResourcesTypeOptions();
            let options = []
            this.groundResourcesTypeOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.groundResourcesTypeOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
        async getFacilityTypeOptions() {
            let result = await getFacilityTypeOptions();
            let options = []
            this.facilityTypeOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.facilityTypeOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
        async getSubordinateCompanyOptions() {
            let result = await getSubordinateCompanyOptions();
            let options = []
            this.subordinateCompanyOptions = []
            if (result.code === 200) {
                for(let item of result.data) {
                    let option = { 
                        label: item, 
                        value: item 
                    }
                    options.push(option)
                }
                this.subordinateCompanyOptions = options
            } else {
                ElMessage({
                    type: 'error',
                    message: result.message
                })
            }
        },
    },
});

export default useDataManagementStore;
